import React from "react";
import { createRoot } from "react-dom/client";
import { CheckCircleFilled, CloseCircleFilled, ExclamationCircleFilled, InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";

const DURATION_MS = 1500; // the old code always used 1.5 s
const ICONS = { success: CheckCircleFilled, error: CloseCircleFilled, warning: ExclamationCircleFilled, info: InfoCircleFilled, loading: LoadingOutlined };

let root = null;
let notices = [];
let seq = 0;

function ensureRoot() {
    if (root) return root;
    const host = document.createElement("div");
    host.className = "ant-message";
    host.style.zIndex = 2010;
    document.body.appendChild(host);
    root = createRoot(host);
    return root;
}

function draw() {
    ensureRoot().render(
        <div>
            {notices.map(({ key, type, content }) => {
                const Icon = ICONS[type] || ICONS.info;
                return (
                    <div key={key} className="ant-message-notice">
                        <div className="ant-message-notice-content">
                            <div className={`ant-message-custom-content ant-message-${type}`} role={type === "error" ? "alert" : "status"}>
                                <Icon />
                                <span>{content}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

function show(type, content, onClose) {
    if (typeof document === "undefined") return;
    const key = ++seq;
    notices = [...notices, { key, type, content }];
    draw();
    setTimeout(() => {
        notices = notices.filter(n => n.key !== key);
        draw();
        if (typeof onClose === "function") onClose();
    }, DURATION_MS);
}

const Toaster = {
    success: (content, duration, onClose) => show("success", content, onClose),
    error: (content, duration, onClose) => show("error", content, onClose),
    warning: (content, duration, onClose) => show("warning", content, onClose),
    loading: (content, duration, onClose) => show("loading", content, onClose),
    info: (content, duration, onClose) => show("info", content, onClose),
};

export default Toaster;